export default __webpack_public_path__ + "aeb8ad89d4836aeaeba19a4332a47909.png";